import { 
    apiGetTransRecord,
    apiGetBankCard,
} from "@/apis/api.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_alarm_msg: 'memberCenter/set_alarm_msg',
    set_trans_list: 'memberCenter/set_trans_list',
    set_trans_list_empty: 'memberCenter/set_trans_list_empty',
    set_bank_card_list: 'memberCenter/set_bank_card_list',
}

// count state 必須是 Object
const state = {
    alarm: {
        type: null,
        msg: null
    },
    transList: [],
    bankCardList: []
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_MEMBER_CENTER_ALARM: (state) => {
        return state.alarm
    },
    GET_MEMBER_TRANS_LIST: (state) => {
        return state.transList
    },
    GET_MEMBER_BANK_CARD_LIST: (state) => {
        return state.bankCardList
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    setAlarmMsg ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_alarm_msg, data)
            resolve()
        })
    },
    getTransRecord ( {dispatch, commit, state}, data ) {
        return new Promise((resolve, reject) => {
            if(data==1){
                commit(types.set_trans_list_empty);
            }
            apiGetTransRecord(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let value = res.data.result.content
                    let totalPage = res.data.result.totalPages
                    if(totalPage >= data){
                        dispatch('getTransRecord', data+1)
                        commit(types.set_trans_list, value);
                    }else{
                        resolve()
                    }
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBankCardList ( {commit} ) {
        return new Promise((resolve, reject) => {
            apiGetBankCard()
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    commit(types.set_bank_card_list, res.data.result.bankInfoList)
                    resolve()
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    }
}
// mutations
const mutations = {
    [types.set_alarm_msg](state, data){
        state.alarm = data
    },
    [types.set_trans_list](state, data){
        data.map( item => {
            state.transList.push(item) 
        })
    },
    [types.set_trans_list_empty](state){
        state.transList = []
    },
    [types.set_bank_card_list](state, data){
        state.bankCardList = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/memberCenter.js